import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import close from "@/assets/images/close.svg";
import horn_fill from "@/assets/images/horn_fill.svg";
import { useShowAds } from "@/hooks/useAds";
import { useAdsStore } from "@/stores/ads-store";

export function Notification() {
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <div
      className={clsx(
        "z-[9] absolute -bottom-2 left-4 right-4 p-4 rounded-2xl border border-[#38312B] bg-[#1D1209] flex items-center justify-between gap-2"
      )}
    >
      <div className="w-6 h-6 flex-shrink-0">
        <img
          src={horn_fill}
          alt="horn_fill"
          className="w-full h-full"
          loading="lazy"
          width={24}
          height={24}
        />
      </div>

      <div className="flex flex-col gap-1">
        <div className="flex items-start gap-2">
          <div className="w-1 h-1 rounded-full bg-[#fec537] mt-1" />

          <p className="flex-1 text-xs linear-text">
            <span>{t("Predict and earn more WLD on AION")} - </span>

            <Link
              to={
                "https://worldcoin.org/mini-app?app_id=app_cb736f87fc78c84c31201f140bcfb5c0"
              }
              target="_blank"
            >
              <span className="underline special pr-1">{t("join_now")}!</span>
            </Link>
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => setVisible(false)}
        className="flex-shrink-0 self-start"
      >
        <img src={close} alt="close" loading="lazy" width={16} height={16} />
      </button>
    </div>
  );
}
